import React from "react";
import "./skeleton-loader.css";

const SkeletonBlock = ({ className = "" }) => (
  <span className={`rgn-skeleton ${className}`} />
);

export const ServicesSkeleton = ({ count = 10 }) => (
  <div className="feature" id="featureSection">
    <div className="container container-lg">
      <SkeletonBlock className="rgn-skeleton-title mb-10" />
      <div className="rgn-skeleton-service-grid">
        {Array.from({ length: count }).map((_, index) => (
          <div className="rgn-skeleton-service" key={index}>
            <SkeletonBlock className="rgn-skeleton-circle" />
            <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-sm" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const VendorGridSkeleton = ({ count = 8 }) => (
  <section className="top-vendors py-80">
    <div className="container container-lg">
      <div className="section-heading">
        <div className="flex-between flex-wrap gap-8">
          <SkeletonBlock className="rgn-skeleton-title" />
          <SkeletonBlock className="rgn-skeleton-action" />
        </div>
      </div>
      <div className="row gy-4 vendor-card-wrapper">
        {Array.from({ length: count }).map((_, index) => (
          <div className="col-xxl-3 col-lg-4 col-sm-6" key={index}>
            <div className="rgn-skeleton-card rgn-skeleton-vendor-card">
              <SkeletonBlock className="rgn-skeleton-logo" />
              <SkeletonBlock className="rgn-skeleton-cover" />
              <div className="p-16">
                <SkeletonBlock className="rgn-skeleton-line" />
                <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-wide" />
                <div className="rgn-skeleton-row">
                  <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-xs" />
                  <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-xs" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const ProductCarouselSkeleton = ({ count = 6 }) => (
  <section className="new-arrival py-20">
    <div className="container container-lg">
      <div className="section-heading">
        <div className="flex-between flex-wrap gap-8">
          <SkeletonBlock className="rgn-skeleton-title" />
          <SkeletonBlock className="rgn-skeleton-action" />
        </div>
      </div>
      <div className="rgn-skeleton-product-grid">
        {Array.from({ length: count }).map((_, index) => (
          <ProductCardSkeleton key={index} />
        ))}
      </div>
    </div>
  </section>
);

export const ProductCardSkeleton = () => (
  <div className="rgn-skeleton-card rgn-skeleton-product-card">
    <SkeletonBlock className="rgn-skeleton-product-thumb" />
    <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-xs mt-12" />
    <SkeletonBlock className="rgn-skeleton-line mt-12" />
    <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-wide mt-8" />
    <div className="rgn-skeleton-product-footer">
      <SkeletonBlock className="rgn-skeleton-price" />
      <SkeletonBlock className="rgn-skeleton-button" />
    </div>
  </div>
);

export const BrandCarouselSkeleton = ({ count = 8 }) => (
  <div className="brand">
    <div className="container container-lg">
      <div className="section-heading brand-heading">
        <div className="flex-between flex-wrap gap-8">
          <SkeletonBlock className="rgn-skeleton-title" />
          <SkeletonBlock className="rgn-skeleton-action" />
        </div>
      </div>
      <div className="rgn-skeleton-brand-grid">
        {Array.from({ length: count }).map((_, index) => (
          <div className="rgn-skeleton-brand-item" key={index}>
            <SkeletonBlock className="rgn-skeleton-brand-image" />
            <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-sm" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const StoreHeaderSkeleton = () => (
  <div className="store-header">
    <SkeletonBlock className="rgn-skeleton-store-logo" />
    <div className="rgn-skeleton-store-info">
      <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-md" />
      <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-wide mt-10" />
      <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-sm mt-10" />
    </div>
  </div>
);

export const CategoryGridSkeleton = ({ count = 8 }) => (
  <>
    <SkeletonBlock className="rgn-skeleton-title mb-16" />
    <div className="categories-grid">
      {Array.from({ length: count }).map((_, index) => (
        <div className="category-card" key={index}>
          <SkeletonBlock className="rgn-skeleton-category-image" />
          <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-sm" />
        </div>
      ))}
    </div>
  </>
);

export const AddressListSkeleton = ({ count = 3 }) => (
  <div className="address-list">
    {Array.from({ length: count }).map((_, index) => (
      <div className="address-card" key={index}>
        <div className="address-left">
          <div className="address-name-row">
            <SkeletonBlock className="rgn-skeleton-radio" />
            <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-md" />
          </div>
          <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-wide mt-12" />
          <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-sm mt-8" />
        </div>
        <div className="address-right">
          <SkeletonBlock className="rgn-skeleton-pill" />
          <SkeletonBlock className="rgn-skeleton-pill" />
        </div>
      </div>
    ))}
  </div>
);

export const OrdersSkeleton = () => (
  <div className="container container-lg bg-light py-24 orders-page-container">
    <div className="row g-3 orders-layout-row">
      <div className="col-xl-3 col-lg-4 col-12 order-0">
        <div className="card h-100 mobile-orders orders-sidebar-card">
          <div className="list-group list-group-flush orders-list orders-scroll">
            {Array.from({ length: 5 }).map((_, index) => (
              <div className="list-group-item order-item order-pill" key={index}>
                <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-md" />
                <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-xs mt-10" />
                <div className="rgn-skeleton-row mt-12">
                  <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-xs" />
                  <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-xs" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="col-xl-9 col-lg-8 col-12 order-1">
        <div className="orders-detail-panel">
          <OrderDetailSkeleton />
        </div>
      </div>
    </div>
  </div>
);

export const OrderDetailSkeleton = () => (
  <>
    <div className="order-card py-20 mb-10">
      <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-md" />
      <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-wide mt-16" />
      <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-wide mt-12" />
      <div className="rgn-skeleton-row mt-20">
        <SkeletonBlock className="rgn-skeleton-button" />
        <SkeletonBlock className="rgn-skeleton-button" />
        <SkeletonBlock className="rgn-skeleton-button" />
      </div>
    </div>
    <div className="card">
      <div className="card-body border-bottom">
        <div className="d-flex gap-10">
          <SkeletonBlock className="rgn-skeleton-order-image" />
          <div className="w-100">
            <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-md" />
            <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-wide mt-12" />
            <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-sm mt-12" />
          </div>
        </div>
      </div>
      <div className="card-body">
        {Array.from({ length: 3 }).map((_, index) => (
          <div className="item-row" key={index}>
            <SkeletonBlock className="rgn-skeleton-item-image" />
            <div className="item-info">
              <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-md" />
              <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-sm mt-10" />
              <SkeletonBlock className="rgn-skeleton-line rgn-skeleton-line-xs mt-10" />
            </div>
          </div>
        ))}
      </div>
    </div>
  </>
);
